import {
  signInWithPopup,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  User as FirebaseUser
} from 'firebase/auth';
// import { doc, setDoc, getDoc } from 'firebase/firestore';
import { auth } from './firebase';
import type { User, LoginCredentials, SignUpData } from '../types/auth';

class AuthService {
  private googleProvider = new GoogleAuthProvider();

  async signInWithGoogle(): Promise<User> {
    try {
      const result = await signInWithPopup(auth, this.googleProvider);
      return this.mapFirebaseUser(result.user);
    } catch (error) {
      console.error('Google sign in error:', error);
      throw new Error('Failed to sign in with Google');
    }
  }

  async signInWithEmail({ email, password }: LoginCredentials): Promise<User> {
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      return this.mapFirebaseUser(result.user);
    } catch (error) {
      console.error('Email sign in error:', error);
      throw new Error('Invalid email or password');
    }
  }

  async signUpWithEmail({ email, password }: SignUpData): Promise<User> {
    try {
      const result = await createUserWithEmailAndPassword(auth, email, password);
      return this.mapFirebaseUser(result.user);
    } catch (error) {
      console.error('Email sign up error:', error);
      throw new Error('Failed to create account');
    }
  }


  async signOut(): Promise<void> {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Sign out error:', error);
      throw new Error('Failed to sign out');
    }
  }

  async getIdToken(): Promise<string | null> {
    if (auth.currentUser) {
      try {
        return await auth.currentUser.getIdToken();
      } catch (error) {
        console.error('Failed to get ID token:', error);
        return null;
      }
    }
    return null;
  }

  onAuthStateChanged(callback: (user: User | null) => void): () => void {
    return onAuthStateChanged(auth, (firebaseUser) => {
      callback(firebaseUser ? this.mapFirebaseUser(firebaseUser) : null);
    });
  }

  private mapFirebaseUser(firebaseUser: FirebaseUser): User {
    return {
      uid: firebaseUser.uid,
      email: firebaseUser.email,
      displayName: firebaseUser.displayName,
      photoURL: firebaseUser.photoURL,
      emailVerified: firebaseUser.emailVerified
    };
  }
}

export const authService = new AuthService();